import React, { useEffect, useState } from 'react';
const headlines = ['Wie sieht die Kommunikation aus, die die Veränderung bestmöglich unterstützt?', 'Welche Maßnahmen sind notwendig für eine nachhaltige Veränderung?', 'Was bleibt alles so wie bisher?'];
export const KonzeptionUmsetzungPage: React.FC = () => {
  const [currentHeadline, setCurrentHeadline] = useState(0);
  const [fadeState, setFadeState] = useState<'visible' | 'fading'>('visible');
  useEffect(() => {
    const interval = setInterval(() => {
      setFadeState('fading');
      setTimeout(() => {
        setCurrentHeadline(prev => (prev + 1) % headlines.length);
        setFadeState('visible');
      }, 500);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <>
      <section className="w-full bg-white py-16 px-6 md:px-12 lg:px-20" data-id="element-474">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-475">
          <div data-id="element-476">
            <h1 className="text-3xl md:text-4xl text-orange-500 font-light mb-6 transition-opacity duration-500" style={{
            opacity: fadeState === 'visible' ? 1 : 0,
            minHeight: '160px'
          }} data-id="element-477">
              {headlines[currentHeadline]}
            </h1>
          </div>
          <div className="flex justify-center" data-id="element-478">
            <img src="https://cdn.magicpatterns.com/uploads/w9ufQBmMZwtiRZDXEHaX2h/Eva-Schifferer-Change_Beratung-Konzeption_Umsetzung.png" alt="Konzeption und Umsetzung" className="max-h-80 object-contain" data-id="element-479" />
          </div>
        </div>
      </section>

      <section className="w-full text-white py-16 px-6 md:px-12 lg:px-20" style={{
      backgroundColor: '#545454'
    }} data-id="element-480">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-481">
          <div data-id="element-482">
            <p className="mb-6 text-base leading-relaxed" data-id="element-483">
              Mit den Erfolgsregeln für gelingende Veränderungsprojekte und
              -kommunikation fokussieren wir die Themen und Stakeholder, auf die
              es wirklich ankommt und bringen sie in den Dialog.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-484">
              Es ist wichtig, Initiativen und Maßnahmen in einer optimalen
              Abfolge miteinander zu verzahnen und dabei die Prinzipien einer
              wirksamen Change Kommunikation mit zu berücksichtigen. Mit einer
              solchen Change Architektur entsteht eine Dramaturgie mit maximalem
              Impact – ein Fahrplan der Orientierung gibt und sicher stellt,
              dass die einzelnen Maßnahmen ineinander greifen.
            </p>
          </div>
          <div data-id="element-485">
            <p className="mb-6 text-base leading-relaxed" data-id="element-486">
              Wir verstehen den Plan als „Fahren auf Sicht" - neue Erkenntnisse
              werden kontinuierlich integriert, denn Change Prozesse sind mehr
              denn je agil und dynamisch.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-487">
              Als Expertin für die Gestaltung komplexer Veränderungen in
              Organisationen ermutige ich mit strategischer Lösungskraft in der
              Umsetzung – damit der Wandel nachhaltig gelebt wird.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-488">
              Dazu zählen Coaching Formate für Führungskräfte, die Moderation
              von Workshops und Großgruppen sowie die Vermittlung von Change
              know how für interne Change Experten.
            </p>
          </div>
        </div>
      </section>
    </>;
};